package nl.volleyplanner.nevoboservice.api

import kotlin.time.Instant
import kotlinx.datetime.format
import kotlinx.datetime.format.DateTimeComponents
import kotlinx.datetime.parse
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.buildClassSerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlin.time.ExperimentalTime


@OptIn(ExperimentalTime::class)
class NevoboDateTimeSerializer : KSerializer<Instant> {
    override val descriptor = PrimitiveSerialDescriptor("LocalDateTime", PrimitiveKind.STRING)

    override fun deserialize(decoder: Decoder): Instant {
        return Instant.parse(decoder.decodeString(), DateTimeComponents.Formats.ISO_DATE_TIME_OFFSET)
    }

    override fun serialize(encoder: Encoder, value: Instant) {
        encoder.encodeString(value.format(DateTimeComponents.Formats.ISO_DATE_TIME_OFFSET))
    }

}

open class NevoboIdentifierSerializer<T : NevoboAPIIdentifier<*>>(
    private val pathTemplate: String,
    private val deserialize: (pathVariables: Map<String, String>) -> T,
    private val serialize: (instance: T) -> Map<String, String>) : KSerializer<T> {
    override val descriptor = buildClassSerialDescriptor(pathTemplate)

    fun getPathString(value: T) : String {
        val pathTemplateNodes = NevoboPathResolver.getPathTemplateNodes(pathTemplate)
        val pathVariables = serialize(value)
        return pathTemplateNodes.map { pathTemplateNode ->
            if (pathTemplateNode.isField) pathVariables.getValue(pathTemplateNode.nodeName)
            else pathTemplateNode.nodeName
        }.joinToString("/")
    }

    fun deserialize(pathString: String) : T {
        val pathVariables = NevoboPathResolver.getPathVariables(pathTemplate, pathString)
        return deserialize(pathVariables)
    }

    override fun deserialize(decoder: Decoder) = deserialize(decoder.decodeString())

    override fun serialize(encoder: Encoder, value: T) {
        encoder.encodeString(getPathString(value))
    }
}